export default __webpack_public_path__ + "static/media/collapse.32cf7ab6.svg";